import jwt from '@/auth/jwt/useJwt'
import { ref } from '@vue/composition-api'

export default function TicketsSection() {
  const route = 'sections'
  const section = ref({})

  const getSectionsRequest = params => jwt.axiosIns.get(route, { params }).then(res => res).catch(() => [])

  const getSectionRequest = id => jwt.axiosIns.get(`${route}/${id}`).then(res => res).catch(() => [])

  const addSectionRequest = eventId => jwt.axiosIns.post(route, { ...section.value, event_id: eventId }).then(res => res)

  const updateSectionRequest = () => jwt.axiosIns.put(`${route}/${section.value.id}`, section.value).then(res => res)

  const deleteSectionRequest = id => jwt.axiosIns.delete(`${route}/${id}`).then(res => res)

  return {
    section, getSectionsRequest, getSectionRequest, addSectionRequest, updateSectionRequest, deleteSectionRequest,
  }
}
